import { useMemo } from "react";

import {
  ViewUsersList,
  ViewSettings,
  ViewProjectList,
  ViewProjectsAssignedTo,
  ViewJobsList,
  ViewJobsFromAssignedProject,
  ManageSubscriptions,
} from "../authorization/Permissions";
import { permissionsService } from "../authorization/UserPermissionsService";

export const DASHBOARD = "dashboard";

export interface MainMenuItemCategory {
  name: string;
  canAccess: boolean;
  path?: string;
  aliases?: string[];
}

export default function useMainMenuService() {
  const menuCategories: MainMenuItemCategory[] = useMemo(
    () => [
      {
        name: DASHBOARD,
        canAccess: true,
      },
      {
        name: "projects",
        canAccess: permissionsService.userHasOneOfThePermissions([
          ViewProjectList,
          ViewProjectsAssignedTo,
        ]),
      },
      {
        name: "jobs",
        canAccess: permissionsService.userHasOneOfThePermissions([
          ViewJobsList,
          ViewJobsFromAssignedProject,
        ]),
      },
      {
        name: "users",
        canAccess: permissionsService.userHasPermissionTo(ViewUsersList),
      },
      {
        name: "subscription",
        canAccess: permissionsService.userHasPermissionTo(ManageSubscriptions),
        aliases: ["/plans", "/usage", "/billing"],
        path: "subscription/usage",
      },
      {
        name: "settings",
        aliases: [
          "/organization-details",
          "/report-templates",
          "/project-properties",
          "/gis-coordinates",
          "/analysis-confidence",
          "/removed-users",
          "/deleted-data",
        ],
        canAccess: permissionsService.userHasPermissionTo(ViewSettings),
        path: "settings/organization-details",
      },
      { name: "help", canAccess: true },
    ],
    []
  );

  return { menuCategories };
}
